export default function handleContent(dataContent) {

    let startFontFamilyTag = '<span style="font-family: Guj_Gopika_Two_Bold;">';
    let endTag = '</span>';
    let contentArr = dataContent.replace(/<p>|<\/p>|<div>|<\/div>/g, '<br>').split('<br>');
    let content = contentArr.filter(line => {
        let strippedLine = line.replace(/<[^>]*>/g, '');
        let decodedLine = strippedLine.replace(/&nbsp;/gi, ' ').trim();
        return decodedLine !== '';
    });
    const finalContent = content.map((str, index) => {
        if (str.match(/font-family:[^;]+;/)) {
            let style = str.match(/<span\s+(?:style="[^"]*"\s*)?[^>]*>/s);
            startFontFamilyTag = style[0];
            return str;
        } else {
            let string = str.replace(/<\/span>/g, '');
            return (startFontFamilyTag + string + endTag);
        }
    });
    return finalContent;
};